import React from "react";
import Routes from "./Routes";
import "./styles/landing.css";

function App() {
  return (
    <div className="App" style={{ position: "relative" }}>
      <Routes />
    </div>
  );
}

export default App;
